import { apiClient } from '~/api/client';
import { CompanyAndAgent } from '~/components/connections/types';

type IndexParams = {
  id: string;
  companyLicense: string;
  export_team_data: boolean;
  period: Period;
};

type IndexResponse = {
  data: {
    loan_officers: CompanyAndAgent[];
  };
};

export const show = async ({ id, companyLicense, ...restParams }: IndexParams) =>
  apiClient.get<IndexResponse>(`/realtors/${id}/loan_officer_companies/${companyLicense}`, {
    params: restParams,
  });
